import FreelanceEnquiry from ".";

export const freelanceEnquiryRoutes = () => [
  {
    path: "/admin/freelance-enquiry",
    component: FreelanceEnquiry,
    layout: "admin",
    routeType: "admin",
    title: "Freelance Management",
  },
];